function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import { checkLimits } from 'shared/helpers/check-limits';
import { getLimitPerCustomer, optionValMap, categorySingularize } from 'shared/helpers/products';
export var ERR_OVER_PURCHASE_LIMIT = 6;
export var ERR_OVER_CATEGORY_LIMIT = 7;
function checkCategoryLimits(param) {
    var cart = param.cart, dispensary = param.dispensary;
    var categoryLimitsEnabled = dispensary.categoryLimitsEnabled, categoryLimits = dispensary.categoryLimits;
    var productTypes = _.map(_.keys(cart), function(k) {
        return cart[k].product.type;
    });
    var quantities = _.map(_.keys(cart), function(k) {
        return cart[k].quantity;
    });
    var options = _.map(_.keys(cart), function(k) {
        return cart[k].option;
    });
    if (categoryLimitsEnabled) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var type = _step.value;
                var indexes = _.reduce(productTypes, function(acc, val, index) {
                    return val === type ? _to_consumable_array(acc).concat([
                        index
                    ]) : acc;
                }, []);
                var __filter = _sliced_to_array(_.filter(categoryLimits, function(c) {
                    return c.name === type;
                }), 1), tmp = __filter[0], _ref = tmp === void 0 ? {} : tmp, tmp1 = _ref.value, limitForType = tmp1 === void 0 ? false : tmp1;
                var amnts = _.map(indexes, function(i) {
                    if (type === 'Flower') {
                        return _.get(optionValMap, options[i], 0.0) * parseInt(quantities[i], 10);
                    }
                    return parseInt(quantities[i], 10);
                });
                if (limitForType && parseFloat(limitForType) < _.sum(amnts)) {
                    var singularType = _.lowerCase(categorySingularize(type));
                    var message = "We only allow the purchase of ".concat(limitForType, "g of ").concat(singularType, " per customer.");
                    if (type !== 'Flower') {
                        message = "We only allow the purchase of ".concat(limitForType, " ").concat(singularType, " items per customer.");
                    }
                    return {
                        v: {
                            withinLimits: false,
                            targetTypes: type,
                            message: message
                        }
                    };
                }
            };
            /* eslint-disable */ for(var _iterator = _.uniq(productTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _ret = _loop();
                if (_type_of(_ret) === "object") return _ret.v;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    /* eslint-enable */ }
    return {
        withinLimits: true
    };
}
function checkLimitPerCustomer(param) {
    var newItemId = param.newItemId, cart = param.cart;
    var _cart_newItemId = cart[newItemId], product = _cart_newItemId.product, option = _cart_newItemId.option, quantity = _cart_newItemId.quantity;
    var limitPerCustomer = getLimitPerCustomer(product, option);
    if (_.isFinite(limitPerCustomer) && limitPerCustomer < quantity) {
        return {
            withinLimits: false,
            message: "This item has a limit of ".concat(limitPerCustomer, " per customer")
        };
    }
    return {
        withinLimits: true
    };
}
/**
 * @returns {{ withinLimits: true } | { withinLimits: false; message: string; code?: number; targetTypes?: string }}
 */ export function checkAllLimits(param) {
    var newItemId = param.newItemId, itemBeingAdded = param.itemBeingAdded, _param_itemBeingRemoved = param.itemBeingRemoved, itemBeingRemoved = _param_itemBeingRemoved === void 0 ? null : _param_itemBeingRemoved, existingItems = param.existingItems, medical = param.medical, dispensary = param.dispensary, customerState = param.customerState, _param_changingQuantity = param.changingQuantity, changingQuantity = _param_changingQuantity === void 0 ? false : _param_changingQuantity, _param_complianceOnly = param.complianceOnly, complianceOnly = _param_complianceOnly === void 0 ? false : _param_complianceOnly, _param_useMultiSubcategories = param.useMultiSubcategories, useMultiSubcategories = _param_useMultiSubcategories === void 0 ? false : _param_useMultiSubcategories;
    var updatedCart = _object_spread({}, existingItems);
    if (newItemId && itemBeingAdded) {
        var itemsInCart = _.values(existingItems || {});
        var matchingProduct = _.find(itemsInCart, {
            id: itemBeingAdded.product.id,
            option: itemBeingAdded.option
        });
        var newQuantity = Number(itemBeingAdded.quantity);
        if (matchingProduct && !changingQuantity) {
            newQuantity += Number(matchingProduct.quantity);
        }
        updatedCart = _object_spread_props(_object_spread({}, existingItems), _define_property({}, newItemId, _object_spread_props(_object_spread({}, itemBeingAdded), {
            quantity: newQuantity
        })));
    }
    // if we're simultaneously removing an item (ie. changing weights)
    // make sure we factor that in before we check limits
    if (itemBeingRemoved) {
        delete updatedCart[itemBeingRemoved];
    }
    var withinDispensaryCategoryLimits = checkCategoryLimits({
        cart: updatedCart,
        dispensary: dispensary
    });
    if (!withinDispensaryCategoryLimits.withinLimits) {
        return _object_spread_props(_object_spread({}, withinDispensaryCategoryLimits), {
            code: ERR_OVER_CATEGORY_LIMIT
        });
    }
    var withinLegalPurchasingLimits = checkLimits({
        medical: medical,
        state: dispensary.location.state,
        cart: updatedCart,
        purchaseState: customerState,
        dispensary: dispensary,
        useMultiSubcategories: useMultiSubcategories
    });
    if (!dispensary.storeSettings.disablePurchaseLimits && !withinLegalPurchasingLimits.withinLimits) {
        return _object_spread_props(_object_spread({}, withinLegalPurchasingLimits), {
            code: ERR_OVER_PURCHASE_LIMIT
        });
    }
    if (complianceOnly) {
        return {
            withinLimits: true
        };
    }
    if (newItemId) {
        var withinDispensaryItemLimits = checkLimitPerCustomer({
            newItemId: newItemId,
            cart: updatedCart
        });
        if (!withinDispensaryItemLimits.withinLimits) {
            return withinDispensaryItemLimits;
        }
    }
    return {
        withinLimits: true
    };
}
